import { RoutePath } from '../../../src/components/route/type';
import { router } from '../../../src/components/route/utils';
import Home from '../../../src/pages/Home';
import AlexanderSolovev from '../../../src/pages/instructors/alexander-solovev/AlexanderSolovev';
import BenjaminKegler from '../../../src/pages/instructors/BenjaminKegler';
import DanielDonaczi from '../../../src/pages/instructors/DanielDonaczi';
import DimitriErmisch from '../../../src/pages/instructors/DimitriErmisch';
import ElenaZander from '../../../src/pages/instructors/ElenaZander';
import EmmanuelBrun from '../../../src/pages/instructors/EmmanuelBrun';
import FalkoZander from '../../../src/pages/instructors/falko-zander/FalkoZander';
import MartinLandolt from '../../../src/pages/instructors/MartinLandolt';
import MichaelProckl from '../../../src/pages/instructors/MichaelProckl';
import WaldemarLotz from '../../../src/pages/instructors/WaldemarLotz';
import Kontakt from '../../../src/pages/Kontakt';
import Agb from '../../../src/pages/legal/Agb';
import Datenschutz from '../../../src/pages/legal/Datenschutz';
import Impressum from '../../../src/pages/legal/Impressum';
import InstructorProgram from '../../../src/pages/martial-arts-instructor-program/InstructorProgram';
import KnowledgeBase from '../../../src/pages/martial-arts-knowledge-base/KnowledgeBase';
import Ranking from '../../../src/pages/martial-arts-ranking/Ranking';
import SelfDefense from '../../../src/pages/martial-arts-self-defense/SelfDefense';
import JuJutsu from '../../../src/pages/martial-arts/JuJutsu';
import MartialArtsFaq from '../../../src/pages/martial-arts/MartialArtsFaq';
import SolovevStyle from '../../../src/pages/martial-arts/SolovevStyle';
import SystemaRyabko from '../../../src/pages/martial-arts/SystemaRyabko';
import Sitemap from '../../../src/pages/Sitemap';
import Training from './pages/training/Training';

const setAppRoutes = () =>
  router.addRoutes([
    { element: <Agb />, name: 'agb', path: RoutePath.Agb, text: 'Agb' },
    {
      element: <Datenschutz />,
      name: 'datenschutz',
      path: RoutePath.Datenschutz,
      text: 'Datenschutz',
    },
    { element: <Impressum />, name: 'impressum', path: RoutePath.Impressum, text: 'Impressum' },

    {
      element: <AlexanderSolovev />,
      name: 'alexander',
      path: RoutePath.AlexanderSolovev,
      text: 'Alexander Solovev',
    },
    { element: <FalkoZander />, name: 'falko', path: RoutePath.FalkoZander, text: 'Falko Zander' },
    { element: <ElenaZander />, name: 'elena', path: RoutePath.ElenaZander, text: 'Elena Zander' },
    {
      element: <DanielDonaczi />,
      name: 'daniel',
      path: RoutePath.DanielDonaczi,
      text: 'Daniel Donaczi',
    },
    {
      element: <BenjaminKegler />,
      name: 'benjamin',
      path: RoutePath.BenjaminKegler,
      text: 'Benjamin Kegler',
    },
    {
      element: <MichaelProckl />,
      name: 'michael',
      path: RoutePath.MichaelProckl,
      text: 'Michael Prockl',
    },
    {
      element: <MartinLandolt />,
      name: 'martin',
      path: RoutePath.MartinLandolt,
      text: 'Martin Landolt',
    },
    {
      element: <DimitriErmisch />,
      name: 'dimitri',
      path: RoutePath.DimitriErmisch,
      text: 'Dimitri Ermisch',
    },
    {
      element: <WaldemarLotz />,
      name: 'waldemar',
      path: RoutePath.WaldemarLotz,
      text: 'Waldemar Lotz',
    },
    {
      element: <EmmanuelBrun />,
      name: 'emmanuel',
      path: RoutePath.EmmanuelBrun,
      text: 'Emmanuel Brun',
    },

    {
      element: <SolovevStyle />,
      name: 'solovev-style',
      path: RoutePath.SolovevStyle,
      text: 'Solovev Style',
    },
    {
      element: <SystemaRyabko />,
      name: 'systema-ryabko',
      path: RoutePath.SystemaRyabko,
      text: 'Systema Ryabko',
    },
    { element: <JuJutsu />, name: 'ju-jutsu', path: RoutePath.JuJutsu, text: 'Ju-Jutsu' },

    { element: <Home />, name: 'home', path: RoutePath.Home, text: 'Startseite' },
    { element: <Kontakt />, name: 'kontakt', path: RoutePath.Kontakt, text: 'Kontakt' },
    { element: <Sitemap />, name: 'sitemap', path: RoutePath.Sitemap, text: 'Sitemap' },

    {
      element: <KnowledgeBase />,
      name: 'ma-kb',
      path: RoutePath.Kampfkunst,
      text: 'Kampfkunst Information',
    },
    {
      element: <Training />,
      name: 'ma-training',
      path: RoutePath.KampfkunstTraining,
      text: 'Kampfkunst Training',
    },
    {
      element: <Ranking />,
      name: 'ma-ranking',
      path: RoutePath.KampfkunstRanking,
      text: 'Kampfkunst Methode',
    },
    {
      element: <MartialArtsFaq />,
      name: 'ma-faq',
      path: RoutePath.KampfkunstFaq,
      text: 'Kampfkunst FAQ',
    },

    {
      element: <InstructorProgram />,
      name: 'instructor-program',
      path: RoutePath.KampfkunstInstructorProgram,
      text: 'Zertifizierung',
    },

    {
      element: <SelfDefense />,
      name: 'self-defense',
      path: RoutePath.Selbstverteidigung,
      text: 'Selbstverteidigung',
    },
  ]);

export default setAppRoutes;
